import { REACT_APP_API_HOST as API_HOST } from "envs";

export const isStage = /stage/gi.test(API_HOST);
export const isPP = /pp/gi.test(API_HOST);
export const isProd = /api.satschel.com/gi.test(API_HOST);
